/**
 * If [version1] is bigger than [version2] it will return true
 * Otherwise it will return false
 *
 * @param version1
 * @param version2
 * @returns
 */
export function appVersionIsBigger(version1?: string, version2?: string): boolean {
  if (!version1 || !version2) return false;

  const sanitizedVersion1 = version1.replace("v", "");
  const sanitizedVersion2 = version2.replace("v", "");

  const v1Parts = sanitizedVersion1.split(".").map(Number);
  const v2Parts = sanitizedVersion2.split(".").map(Number);

  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    const v1 = v1Parts[i] || 0;
    const v2 = v2Parts[i] || 0;

    if (v1 > v2) return true;
    if (v1 < v2) return false;
  }

  return false; // versions are equal
}

export function getSystemTheme(): "light" | "dark" {
  const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return isDarkMode ? "dark" : "light";
}
